const mobileRegex = /^1[3456789]\d{9}$/;
const phoneRegex = /0\d{2,3}-\d{7,8}|\(?0\d{2,3}[)-]?\d{7,8}|\(?0\d{2,3}[)-]*\d{7,8}/;
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const idCardRegex = /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}([0-9]|X)$/;

export {
  mobileRegex,
  phoneRegex,
  emailRegex,
  idCardRegex
}


// WEBPACK FOOTER //
// ./src/utils/reConsts.js